import AbstractPopupMediator from "../../ui/AbstractPopupMediator";
import SystemMessage from "../model/SystemMessage";
import SystemMessageEvent from "../model/SystemMessageEvent";
import SystemMessageOption from "../model/SystemMessageOption";

export default class SystemMessagePopupMediator extends AbstractPopupMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        /** @type {SystemMessage} */
        this._systemMessage = this.getCustomData().systemMessage;
    }

    initialize() {
        super.initialize();

        this._target.panel.initialY = this._target.panel.y;

        this._target.panel.headerTextField.text = this._systemMessage.title;
        this._target.panel.bodyTextField.text = this._systemMessage.description;

        this._initializeButtons();

        this.stretchBackground();
        this.preventClickThrough();

        this._show();

        this.registerEventListener(SystemMessageEvent.DISMISS_ALL, this._close.bind(this));
    }

    _initializeButtons() {
        const amountOfButtons = this._systemMessage.options.length;
        if (amountOfButtons > SystemMessagePopupMediator.MAX_SUPPORTED_OPTIONS) {
            console.warn('[SystemMessagePopupMediator] Only supports a maximum of 2 options!');
        }

        const availableAmountOfButtons = Math.min(SystemMessagePopupMediator.MAX_SUPPORTED_OPTIONS, amountOfButtons);
        this._currentButtonPanel = this._target.panel[`buttonPanel${availableAmountOfButtons}`];

        // Make the correct button panel visible, so that the correct amount of buttons show
        for (let i = 1; i <= SystemMessagePopupMediator.MAX_SUPPORTED_OPTIONS; i++) {
            this._target.panel[`buttonPanel${i}`].visible = i === amountOfButtons;
        }


        for (let i = 0; i < this._systemMessage.options.length; i++) {
            const option = this._systemMessage.options[i];
            const buttonSkin = this._currentButtonPanel[`button${i + 1}`];
            if (!buttonSkin) {
                console.warn(`[SystemMessagePopupMediator] Current button panel doesn't support or is missing 'button${i + 1}'.`);
                continue;
            }

            buttonSkin.customData = {
                option
            };

            this.createButton(buttonSkin, this._handleOptionButton.bind(this), option.text);
        }
    }

    _handleOptionButton(evt) {
        const button = evt.target;

        /** @type {SystemMessageOption} */
        const option = button.skin.customData.option;

        if (option.callback) {
            option.callback.call(this);
        }

        this._close();
    }

    _show() {
        this._target.bg.alpha = 0;
        createjs.Tween.get(this._target.bg)
            .to({ alpha: 1 }, 350, createjs.Ease.sineInOut);

        this._target.panel.y = this._target.panel.initialY + 100;
        this._target.panel.alpha = 0;
        createjs.Tween.get(this._target.panel)
            .to({
                alpha: 1,
                y: this._target.panel.initialY
            }, 450, createjs.Ease.backOut);
    }

    _close() {
        this.removeClickListenersFromAllButtons();

        createjs.Tween.removeTweens(this._target.bg);
        createjs.Tween.removeTweens(this._target.panel);

        createjs.Tween.get(this._target.bg)
            .to({ alpha: 0 }, 250, createjs.Ease.sineInOut);

        createjs.Tween.get(this._target.panel)
            .to({
                alpha: 0,
                y: this._target.panel.initialY - 10
            }, 250, createjs.Ease.sineOut)
            .call(() => {
                this.closePopup(this._target);
            });
    }
}

SystemMessagePopupMediator.MAX_SUPPORTED_OPTIONS = 2;